/**
 * Absolute paths for the Line Manager Reviews section's routes.
 *
 * Both the router's route records, the annual review screen's post-action
 * redirect, and the annual list table's `route-prefix` import from here — so a
 * path's route registration and every place that navigates to or matches
 * against it are one string rather than several copies that fail silently
 * when one is mistyped. Mirrors `@/pages/compliance-reviews/routes`.
 */
export const LINE_MANAGER_REVIEWS_PATH = '/line-manager-reviews'

/** Line Manager Reviews → Annual Process (SMCR-335). Single queue, no sub-tabs. */
export const LINE_MANAGER_ANNUAL_PATH = `${LINE_MANAGER_REVIEWS_PATH}/annual`
